// ag-grid-react v29.3.4
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var counter = 0;
function generateNewKey() {
    return "agPortalKey_" + ++counter;
}
exports.default = generateNewKey;
